<div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutGap="20px" (click)="goBack()" class="link">
      <!-- <div >
                    <img src="assets/icons/left-arrow-icon.svg" alt="">
                </div> -->
      <div class="equipment-id">
        <!-- Title -->
        <!-- <label class="sub-item">Home </label> -->
        <h2 class="ui primary header">Chat with NCC</h2>
      </div>
    </div>
  </div>
  <div class="ui divider" appMargin marginY="3"></div>
  <div *ngIf="success || error" tamsyMargin marginY="10px">
    <esl-message-toast [(message)]="error"></esl-message-toast>
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
  </div>
</div>

<div fxLayout="row" fxLayoutGap="30px">
  <div fxFlex="grow">
    <div fxLayout="row">
      <!-- <app-all-conversations fxFlex="35%" [conversations]="conversationsData" ></app-all-conversations>
      <app-conversation-view fxFlex="65%"></app-conversation-view> -->
    </div>

    <router-outlet></router-outlet>

  </div>
  <div fxFlex="30%" fxLayout="column" fxLayoutGap="10px">
    <div class="ui secondary segment" appPadding="7">
      <div [innerHtml]="sideBarMessage"></div>
    </div>
  </div>
</div>
